import { render, staticRenderFns } from "./KEButtonFeedback.vue?vue&type=template&id=0c1e71f0&scoped=true&"
import script from "./KEButtonFeedback.vue?vue&type=script&lang=ts&"
export * from "./KEButtonFeedback.vue?vue&type=script&lang=ts&"
import style0 from "./KEButtonFeedback.vue?vue&type=style&index=0&id=0c1e71f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1e71f0",
  null
  
)

export default component.exports